module.exports = __webpack_public_path__ + "static/media/adult-medium-light-skin-tone-svgrepo-com.44c74af7.svg";